import React from "react";
import "./screenHeightLayout.scss";

function ScreenHeightLayout(props) {
  const { children } = props;
  return (
    <div className={`screen-height ${props.className && props.className}`}>
      {children}
    </div>
  );
}

export { ScreenHeightLayout };
